import { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { Box, Flex, AccordionItem, Accordion, AccordionButton, AccordionIcon, AccordionPanel, Divider } from "@chakra-ui/react";

import { getUserDetailsUsingDsrMembersArray } from '../../../profile/helpers/user-helper';
import DsrFaqTextAreaInput from "../../../forms/TextareaField/components/DsrFaqTextAreaInput";
import LaunchdeckButton from "../../../global/components/helper-components/components/LaunchdeckButton";
import EditQuestionAndAnswerModule from "./EditQuestionAndAnswerModule";
import { displayReactIcon } from '../../helpers/dsr-display-helpers';
import { TbSquareChevronUpFilled, TbSquareChevronDownFilled } from "react-icons/tb";
import { displayElapsedDurationSinceTimestamp } from "../../../global/helpers/time-format-helpers";
import { getThisUserIdToken } from "../../../global/helpers/global-helpers";
import { manageDsrFaqContent } from "../../actions/dsr-faq-actions";
import LaunchdeckSpinner from "../../../global/components/helper-components/components/LaunchdeckSpinner";



function AnsweredFaqDisplay({
  dsrId,
  dsrTemplateId,
  isRoomTemplate,
  dsrTeamMembers,
  answeredQuestions,
  isDsrAdmin,
  manageDsrFaqContent,
  displayReorderButtons,
  isPagePreviewMode,
  // Redux state
  isArchivedDsr
}) {

  const [showEditInput, setShowEditInput] = useState(false)
  const [showEditQuestionInput, setShowEditQuestionInput] = useState(false)
  const [actOnQuestionId, setActOnQuestionId] = useState("")
  const [openedQuestionId, setOpenedQuestionId] = useState("")
  const [unfocusBackground, setUnfocusBackground] = useState(false)
  const [answeredQuestionsDisplay, setAnsweredQuestionsDisplay] = useState(null)

  const [processingReorderedQuestion, setProcessingReorderedQuestion] = useState("")


  useEffect(() => {
    if (answeredQuestions) {
      setAnsweredQuestionsDisplay(answeredQuestions)
      setProcessingReorderedQuestion("")
    }
  }, [answeredQuestions]);


  function handleEditAnswerClick(questionId, userIsAuthor) {
    !!userIsAuthor ? setShowEditQuestionInput(true) : setShowEditInput(true)
    setActOnQuestionId(questionId)
    setUnfocusBackground(true)
  }

  function handleCloseEditInput() {
    setShowEditInput(false)
    setShowEditQuestionInput(false)
    // setOpenedQuestionId("")
    setUnfocusBackground(false)
  }


  function handleOpenAccordion(questionId) {
    setOpenedQuestionId(questionId)
  }

  const handleClickChangePositionButton = (questionId, direction) => {
    if (dsrId && questionId && direction) {
      manageDsrFaqContent({
        processEvent: "reorder-faq-questions",
        payload: {
          dsrId: isRoomTemplate ? dsrTemplateId : dsrId,
          questionId,
          direction,
          isRoomTemplate
        }
      })
      setProcessingReorderedQuestion(questionId)
    }
  }

  function renderChangePositionButtons(questionId) {
    return (
      <Flex w='100%' direction='column' justify='flex-end' align='center' gap={2} px='0.5em'>
        {(processingReorderedQuestion === questionId) ?
          <Box mt='0.3em' ml='0.2em'>
            <LaunchdeckSpinner boxSize='1.5em' />
          </Box>

          :
          <Box visibility={processingReorderedQuestion ? 'hidden' : 'visible'}>
            <Box cursor='pointer' onClick={() => handleClickChangePositionButton(questionId, 'up')}
              _hover={{ 'svg': { color: 'gray.500' } }}
            >
              <Box as={TbSquareChevronUpFilled} boxSize="1.5em" color="gray.300" transition="color 0.3s ease" />
            </Box>


            <Box cursor='pointer' onClick={() => handleClickChangePositionButton(questionId, 'down')}
              _hover={{ 'svg': { color: 'gray.500' } }}
            >
              <Box as={TbSquareChevronDownFilled} boxSize="1.5em" color="gray.300" transition="color 0.3s ease" />
            </Box>
          </Box>
        }

      </Flex>
    )
  }



  const faqSet = (answeredQuestionsDisplay?.length > 0) && answeredQuestionsDisplay.map((question, questionIndex) => {
    const { questionId, questionTextContent, questionAuthorUserId,
      answerTextContent, answerCreatedAt, answerEditedAt, answerAuthorUserId } = question || {};
    const isThisQuestion = (actOnQuestionId === questionId) ? true : false;


    // Checks if current session user is a seller member. If yes, then render editing answer option.
    const thisUserIdToken = getThisUserIdToken();
    const questionAuthorProfile = getUserDetailsUsingDsrMembersArray(dsrTeamMembers, questionAuthorUserId);
    const answerAuthorProfile = getUserDetailsUsingDsrMembersArray(dsrTeamMembers, answerAuthorUserId);

    const userIsQuestionAuthor = (questionAuthorProfile?.userId === thisUserIdToken || isRoomTemplate === true) ? true : false;
    const userIsAuthor = (answerAuthorProfile?.userId === thisUserIdToken || isRoomTemplate === true) ? true : false;

    const isEdited = answerEditedAt ? true : false;

    return (
      <Flex key={`qn_` + questionIndex + questionId} w='100%' justify='space-between'>

        <Box flex='auto' w='100%' mb='2.6em'
          bg={(unfocusBackground && isThisQuestion) ? 'gray.200' : 'white'} transition="background-color 0.8s ease"
          border='1px solid rgba(203, 213, 224, 0.5)' rounded='0.25em'>


          {(showEditQuestionInput && isThisQuestion && userIsAuthor) ? <Box p='1em'>
            <EditQuestionAndAnswerModule
              name="editFaqQ&A"
              label="Edit"
              sublabel=""
              placeholder=""
              fontSize='1em'
              handleCloseInputArea={handleCloseEditInput}
              dsrId={dsrId}
              questionId={actOnQuestionId}
              currentQuestionTextValue={questionTextContent}
              currentAnswerTextValue={answerTextContent}
              isDsrAdmin={isDsrAdmin}
            />
          </Box> :
            <>
              <Accordion width='100%' allowToggle>
                <AccordionItem border='0px' px='1em' py='1em'>
                  <AccordionButton _hover={{ background: 'none', }} fontSize='1em' onClick={() => handleOpenAccordion((openedQuestionId === questionId) ? "" : questionId)} fontWeight={((openedQuestionId === questionId)) ? '800' : '500'} >
                    <Box flex="1" textAlign="left" lineHeight='1.5em'>
                      <Flex justify='space-between'>
                        {(showEditQuestionInput && isThisQuestion) ?
                          <DsrFaqTextAreaInput
                            userActionRequired='edit-faq-question'
                            name="editFaqQuestion"
                            label="Edit"
                            sublabel=""
                            placeholder=""
                            fontSize='1em'
                            htmlFor="editFaqQuestion"
                            handleCloseInputArea={handleCloseEditInput}
                            dsrId={dsrId}
                            questionId={actOnQuestionId}
                            setActOnQuestionId={setActOnQuestionId}
                            currentValue={questionTextContent}
                          />
                          : <Box color='brandDark.500'>{questionTextContent}</Box>}
                        <AccordionIcon />
                      </Flex>


                      {(answerAuthorProfile && answerCreatedAt) &&
                        <Flex fontStyle='italic' fontSize='0.75em' color={(showEditInput && !userIsQuestionAuthor && isThisQuestion) ? 'brandDark.500' : 'gray.500'} fontWeight='400' align='center'>
                          {(showEditInput && !userIsQuestionAuthor && isThisQuestion) ? <>
                            <Box>{displayReactIcon('lock', '1em')}</Box>
                            <Box>Question owned by</Box>
                            <Box pl='0.5em' fontWeight='semibold'> {answerAuthorProfile.memberName}</Box>
                          </>
                            :
                            <Box lineHeight={'1.2em'} display={['block', 'flex']} gap={[0, 2]} mt='0.5em'>
                              <Box>Answered by <strong>{answerAuthorProfile.memberName}</strong> </Box>
                              <Box> {displayElapsedDurationSinceTimestamp(answerCreatedAt)}  </Box>
                            </Box>
                          }
                        </Flex>
                      }
                    </Box>


                  </AccordionButton>

                  <AccordionPanel>
                    {(showEditInput && isThisQuestion) ?
                      <DsrFaqTextAreaInput
                        userActionRequired='edit-faq-answer'
                        name="EditFaqAnswer"
                        label=""
                        sublabel=""
                        currentValue={answerTextContent}
                        fontSize='1em'
                        htmlFor="editFaqAnswer"
                        handleCloseInputArea={handleCloseEditInput}
                        dsrId={dsrId}
                        questionId={actOnQuestionId}
                        setActOnQuestionId={setActOnQuestionId}
                        bg={(unfocusBackground && isThisQuestion) && 'white'}
                      />
                      :

                      <>
                        <Divider />
                        <Box my='1.5em'>
                          <Box fontWeight='400' lineHeight='1.5em' fontSize='0.9em' color='black' whiteSpace='pre-line'>{answerTextContent}</Box>
                          {isEdited && <Box fontSize='0.6em' color='gray.700'>EDITED</Box>}
                        </Box>

                        {(userIsAuthor || isDsrAdmin) && (!isPagePreviewMode) && (!isArchivedDsr) &&
                          <Flex justify='flex-end'>
                            <LaunchdeckButton bg='brand.500' color='white' fontSize='0.75em' onClick={() => handleEditAnswerClick(questionId, userIsAuthor)} label='Edit' />
                          </Flex>
                        }
                      </>
                    }

                  </AccordionPanel>
                </AccordionItem>
              </Accordion>

            </>

          }
        </Box>

        {!!displayReorderButtons && <Box flex='1em'>{renderChangePositionButtons(questionId)}</Box>}
      </Flex>
    )
  }
  )

  return faqSet
}

function mapStateToProps(state) {
  return {
    isDsrAdmin: state.dsrAdmin.isDsrAdmin,
    dsrTemplateId: state.dsrTemplateId.results,
    isArchivedDsr: state.isArchivedDsr.results
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      manageDsrFaqContent
    },
    dispatch,
  )


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AnsweredFaqDisplay));
